import slide5 from '../../../../assets/slides/s3.2.mp4';

const About = () => {
  return (
    <div className="max-w-screen-xl mx-auto px-5 py-16 md:py-20">
      <fieldset className="border-4 border-slate-800 dark:border-white rounded-3xl p-6 md:p-10 ">
        
        {/* Legend */}
        <legend className="font-[blanka] dark:text-white text-3xl md:text-4xl px-6 text-center md:text-left">
          Who is Studio Mercy?
        </legend>

        <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-center mt-6">
          
          {/* Video on the left */}
          <div className="w-full md:w-5/12 flex-shrink-0">
            <div className="rounded-2xl overflow-hidden shadow-xl border border-slate-300 dark:border-slate-700">
              <video
                src={slide5}
                autoPlay
                loop
                muted
                playsInline
                className="w-full h-full object-cover aspect-video"
              />
            </div>
          </div>

          {/* Text Content on the right */}
          <div className="w-full md:w-7/12 space-y-4 text-lg leading-relaxed text-slate-700 dark:text-white">
            <p>
              Studio Mercy is an Experimental Hip-Hop Musician, Voice Actor & Narrator 
              who creates YouTube videos encompassing video-game soundtracks and deep dives 
              about how they are made and performed.
            </p>
            
            <p>
              Mercy's genres focus on Breakbeat, Drum & Bass (DnB), Lo-fi, Old School Hip-Hop, 
              and Rock.
            </p>

            <p className="pt-2 ">
              Studio Mercy is affiliated with <strong>Death Engine Records</strong> and serves 
              as a subsidiary of Tats Top Videos Narration Department on YouTube.
            </p>
          </div>

        </div>
      </fieldset>
    </div>
  );
};

export default About;